import { FC, useState } from 'react';

import { Button, Modal } from 'antd';
import { duplicateProductSchema } from 'common/validation';
import { Form, FormInput } from 'components/Form';
import { useNavigate } from 'react-router-dom';

import { notify } from 'common/utils';

import { duplicateProduct } from '../../../http/productApi';

import styles from './duplicate-product-modal.module.scss';

interface IDuplicateProductModalProps {
  id: number;
  isOpen: boolean;
  closeModal: () => void;
}

interface IDuplicateProductForm {
  title: string;
}

export const DuplicateProductModal: FC<IDuplicateProductModalProps> = ({
  id,
  isOpen,
  closeModal,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: IDuplicateProductForm) => {
    setLoading(true);

    try {
      const result = await duplicateProduct(id, values.title);

      navigate(`/product/${result.id}`);
    } catch {
      notify('Failed to duplicate product', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      className={styles.modalWrapper}
      destroyOnClose
      open={isOpen}
      footer={null}
      onCancel={closeModal}
    >
      <span className={styles.title}>Duplicate product</span>
      <div className={styles.formContainer}>
        <Form
          initialValues={{ title: '' }}
          validation={duplicateProductSchema}
          onSubmit={onSubmit}
        >
          <div className={styles.fields}>
            <FormInput
              required
              name="title"
              label="New title"
              className={styles.field}
            />

            <div className={styles.buttonWrapper}>
              <Button
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                className={styles.button}
              >
                Duplicate
              </Button>
              <Button
                disabled={loading}
                onClick={closeModal}
                type="default"
                className={styles.button}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};
